module.exports = "<router-outlet></router-outlet>\n<app-footer *ngIf=\"isFooter\"></app-footer>\n"